import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { QRSPApp } from './components/QRSPApp';
import { MobileApp } from './components/MobileApp';
import { MobileDemoFlow } from './components/MobileDemoFlow';
import { LandingPage } from './components/LandingPage';
import { CooperativeLandingPage } from './components/CooperativeLandingPage';
import { ArchitectureDiagram } from './components/ArchitectureDiagram';
import { ProjectStructure } from './components/ProjectStructure';

function App() {
  return (
    <Routes>
      <Route path="/" element={<CooperativeLandingPage />} />
      <Route path="/coupon" element={<LandingPage />} />
      <Route path="/app" element={<MobileApp />} />
      <Route path="/desktop" element={<QRSPApp />} />
      <Route path="/demo" element={<MobileDemoFlow />} />
      <Route path="/architecture" element={<ArchitectureDiagram />} />
      <Route path="/structure" element={<ProjectStructure />} />
    </Routes>
  );
}

export default App;
